module.exports = __webpack_public_path__ + "media/images/top/review-sample02-e3e8c483216d79812c023180de6072a6.jpg";